import selectFolderWithFallback from "./selectFolderWithFallback";
export interface MailFolderRouteParameters {
    folderId: string;
}

export default function mailFolderRouteHandler(parameters: MailFolderRouteParameters): void {
    selectFolderWithFallback(parameters.folderId);
}
